import { render, staticRenderFns } from "./DataTableServices.vue?vue&type=template&id=5327f812&"
import script from "./DataTableServices.vue?vue&type=script&lang=js&"
export * from "./DataTableServices.vue?vue&type=script&lang=js&"
import style0 from "./DataTableServices.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports